import { axios } from './ServiceUtils';

const getActiveSession = async () =>
  await axios.get(`api/auth/disession`).then(response => response.data);

export { getActiveSession };
